import { useIntl } from 'react-intl';
import styled from 'styled-components';

interface VideoThumbnailProps {
  active: boolean;
  isPlaying: boolean;
  title: string;
  subTitle?: string;
  thumbnailSrc: string;
  onClick(): void;
}

function VideoThumbnail({ active, title, subTitle, thumbnailSrc, onClick, isPlaying }: VideoThumbnailProps) {
  const { formatMessage } = useIntl();

  return (
    <ThumbnailContainer $active={active} onClick={onClick} role="button">
      <img src={thumbnailSrc} className="position-absolute w-100 opacity-25" />
      <div className="card-header flex-fill p-12px">
        <h3 className="text-white fs-5 fw-medium lh-1">{title}</h3>
        <p className="text-light fs-6">{subTitle}</p>
      </div>
      {isPlaying && active && (
        <div className="card-footer d-flex justify-content-end border-0 p-12px">
          <span className="badge rounded-pill badge-white text-black fs-6 lh-1 py-1" role="status">
            {formatMessage({ id: 'discover.videos.nowPlaying' })}
          </span>
        </div>
      )}
    </ThumbnailContainer>
  );
}

const ThumbnailContainer = styled.div.attrs<{ $active: boolean }>({
  className:
    'video-thumbnail card card-bordering-white d-flex flex-row flex-lg-column mb-2 mx-4 m-lg-0 me-lg-3 overflow-hidden',
})`
  width: 250px;
  cursor: pointer;
  ${({ $active }) => ($active ? 'outline: 0.2rem solid white;' : undefined)}
`;

export { VideoThumbnail };
